import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

export default {
  showToast(text, options, customOptions) {
    if (!text) return
    const currentToast = Vue.toasted.show(text, {
      theme: 'bubble',
      position: 'bottom-right',
      duration: (customOptions && customOptions.duration) || null,
      className: (customOptions && customOptions.className) || 'custom-toast__info',
      action: (customOptions && customOptions.action) || {
        text: '',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      },
      ...options,
    })
    if (customOptions && customOptions.hasReturnValue) {
      // eslint-disable-next-line consistent-return
      return currentToast
    }
  },
}
